import { ConsentWorkflow, FormDefinitionType } from '@/api/dtos';
import ConsentStandardFields from '@/components/consent/ConsentStandardFields';
import ConsentStandardForm from '@/components/consent/ConsentStandardForm';
import { useScopedField } from '@ngt/forms-core';
import { GroupedField, ToggleButtonGroup } from '@ngt/opms';
import { FC } from 'react';

const MainConsentQuestions: FC = () => {
    const { state: { value: workflow } } = useScopedField<ConsentWorkflow>(
        'workflow',
        { value: true },
        false,
        false
    );
    const disabled = workflow !== ConsentWorkflow.Standard;

    return (
        <>
            <GroupedField
                propertyPath="participantAgreedToProvideBloodSample"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
            <GroupedField
                propertyPath="participantAgreedToCompleteQuestionnaires"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
        </>
    );
};

const MainConsentStandardForm: FC = () => (
    <ConsentStandardForm
        formDefinitionId={FormDefinitionType.MainConsentForm}
    >
        <ConsentStandardFields picfTypeName="Main">
            <MainConsentQuestions />
        </ConsentStandardFields>
    </ConsentStandardForm>
);

export default MainConsentStandardForm;
